var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articles-list container text-white"},_vm._l((_vm.blogPosts),function(post,index){return _c('list-post-item',{key:index,staticClass:"mb-20",attrs:{"blog-post":post,"even-list-item":(index+1)%2 === 0,"labels":_vm.labels}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }